<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Initiative Poste Verte" />
            <PosteVerte />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PosteVerte from '../Services/PosteVerte'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PosteVertePage',
    components: {
        NavBar,
        PageTitle,
        PosteVerte,
        FooterComp,
    }
}
</script>